import { Grid, TextInput } from "@mantine/core";
import { TranslateButton } from "ui";
import { UseFormReturnType } from "@mantine/form";
import type { ReactNode } from "react";
import { EventFormValues } from "./types";

interface EventFormTitleProps {
  form: UseFormReturnType<EventFormValues>;
  isPtFirst: boolean;
  t: (key: string) => string;
  handlePaste: (
    e: React.ClipboardEvent<HTMLTextAreaElement | HTMLInputElement>,
    field: keyof EventFormValues
  ) => void;
  /**
   * Desk mode: wraps the title pair and the subtitle pair separately. Absent
   * everywhere else, which renders the four columns exactly as before.
   */
  wrapSection?: (field: "title" | "subtitle", cols: ReactNode) => ReactNode;
}

const noWrap = (_field: "title" | "subtitle", cols: ReactNode) => cols;

export const EventFormTitle = ({
  form,
  isPtFirst,
  t,
  handlePaste,
  wrapSection = noWrap,
}: EventFormTitleProps) => {
  return (
    <>
      {wrapSection(
        "title",
        <>
          <Grid.Col span={6}>
            <TextInput
              label={`${t("events.event_title")} (${isPtFirst ? "pt" : "en"})`}
              {...form.getInputProps(isPtFirst ? "title_pt" : "title")}
              rightSection={
                <TranslateButton
                  originalText={
                    isPtFirst ? form.values.title : form.values.title_pt
                  }
                  tragetLang={isPtFirst ? "pt" : "en"}
                  onTranslated={(translatedText) => {
                    form.setFieldValue(
                      isPtFirst ? "title_pt" : "title",
                      translatedText
                    );
                  }}
                />
              }
              onPaste={(e) => {
                handlePaste(e, isPtFirst ? "title_pt" : "title");
              }}
              withAsterisk={form.values.published}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label={`${t("events.event_title")} (${isPtFirst ? "en" : "pt"})`}
              {...form.getInputProps(isPtFirst ? "title" : "title_pt")}
              rightSection={
                <TranslateButton
                  originalText={
                    isPtFirst ? form.values.title_pt : form.values.title
                  }
                  tragetLang={isPtFirst ? "en" : "pt"}
                  onTranslated={(translatedText) => {
                    form.setFieldValue(
                      isPtFirst ? "title" : "title_pt",
                      translatedText
                    );
                  }}
                />
              }
              onPaste={(e) => {
                handlePaste(e, isPtFirst ? "title" : "title_pt");
              }}
              withAsterisk={form.values.published}
            />
          </Grid.Col>
        </>
      )}
      {wrapSection(
        "subtitle",
        <>
          <Grid.Col span={6}>
            <TextInput
              mt="md"
              label={`${t("events.subtitle")} (${isPtFirst ? "pt" : "en"})`}
              {...form.getInputProps(isPtFirst ? "subTitle_pt" : "subTitle")}
              rightSection={
                <TranslateButton
                  originalText={
                    isPtFirst ? form.values.subTitle : form.values.subTitle_pt
                  }
                  tragetLang={isPtFirst ? "pt" : "en"}
                  onTranslated={(translatedText) => {
                    form.setFieldValue(
                      isPtFirst ? "subTitle_pt" : "subTitle",
                      translatedText
                    );
                  }}
                />
              }
              onPaste={(e) => {
                handlePaste(e, isPtFirst ? "subTitle_pt" : "subTitle");
              }}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              mt="md"
              label={`${t("events.subtitle")} (${isPtFirst ? "en" : "pt"})`}
              {...form.getInputProps(isPtFirst ? "subTitle" : "subTitle_pt")}
              rightSection={
                <TranslateButton
                  originalText={
                    isPtFirst ? form.values.subTitle_pt : form.values.subTitle
                  }
                  tragetLang={isPtFirst ? "en" : "pt"}
                  onTranslated={(translatedText) => {
                    form.setFieldValue(
                      isPtFirst ? "subTitle" : "subTitle_pt",
                      translatedText
                    );
                  }}
                />
              }
              onPaste={(e) => {
                handlePaste(e, isPtFirst ? "subTitle" : "subTitle_pt");
              }}
            />
          </Grid.Col>
        </>
      )}
    </>
  );
};
